import React from "react";
import { Column, MiniChartsRow, MiniRowName, RowName, GridContainer} from "./Evaluation.styled";
import EvaluationChartItem from './EvaluationChartItem'
import SbToolProjectVersionService from "../../../service/projectVersionService";
import ProjectService from "../../../service/projectService";
import TotalEvaluationChart from "./TotalEvaluationChart";
import FlatButton from "material-ui/FlatButton";
import sbToolParamsService from "../../../service/paramsService";
import {LoadingIcon} from "../../../../core/components/common/loading";



export default class EvaluationGrid extends React.Component<any,any>  {
  state = {
      projectVersions: [],
      versionsData : [],
      isLoading: true,
    }


  componentDidMount() {
    this.fetchDataForCharts()
 }

  openFullViewGrid () {
    sbToolParamsService.selectedCriterion = undefined
  }
  fetchDataForCharts () {
    this.setState({isLoading: true})
    let projectID = SbToolProjectVersionService.projectVersion.project.projectId
    ProjectService.getVersionsScore(projectID).then(resp => {
      this.setState({projectVersions: resp.map(el => el.projectVersionId)})
      let sortedVariants = resp.sort((a,b)=> {
        let comparison = 0;
        if (a.projectVersionId > b.projectVersionId) {
          comparison = 1;
        } else if (a.projectVersionId < b.projectVersionId) {
          comparison = -1;
        }
        return comparison;
      })
      this.setState({versionsData:sortedVariants})
    }).then(()=>this.setState({isLoading:false})
    ).catch(error => console.error('err',error))
  }
  render() {
    let {projectVersions, versionsData,isLoading} = this.state
    let isCriterionSelected = sbToolParamsService.selectedCriterion

    let currentOpenedVersion = SbToolProjectVersionService.projectVersion.versionId
    let criteriaColors = {
    env: "#667B3B",
    soc: "#36537B",
    eco: "#B57031",
    loc: "#555555"
  }
    return (
      <div className={"EvaluationGrid"} style={{backgroundColor: "#F9F9F9", borderRadius: 10, padding:20, maxWidth:"100%"}}>
        <RowName style={{fontWeight: 700, color: "#000",height: "2rem", display:"block",marginBottom: "2rem"}}>Průběžná analýza výsledků:</RowName>
        { !isCriterionSelected ?
          <div style={{display:"flex"}}>
            <div>
            <Column>
              <RowName>Hodnocení lokality:</RowName>
              <RowName style={{fontWeight: 700, color: "#000", height: "37px"}}>Hodnocení budovy:</RowName>
              <RowName>Environmentální kritéria:</RowName>
              <RowName>Sociální kritéria:</RowName>
              <RowName>Ekonomická kritéria:</RowName>
              <RowName>Celkové průběžné hodnocení projektu:</RowName>
            </Column>
          </div>
            <div style={{display:"flex", flexDirection: "column", alignItems:"flex-start", overflowX:"auto", overflowY:"hidden"}}>
              {versionsData.length > 0 &&
                <EvaluationChartItem criteria={versionsData[0].criterionListLocality} color={criteriaColors.loc} withCharts={!isCriterionSelected} total={versionsData[0].localityScore}/>
              }
              <GridContainer versions={projectVersions}>
                {versionsData.map((versionData)=>
                  <Column key={versionData.projectVersionId}>
                    {currentOpenedVersion === versionData.projectVersionId ?
                  <span style={{fontWeight: 700,fontSize:"2rem"}} >V.{versionData.version}</span>
                  :
                  <span style={{fontSize:"2rem"}}>V.{versionData.version}</span>}
                  <EvaluationChartItem criteria={versionData.criterionListEnvironmental} color={criteriaColors.env} withCharts={!isCriterionSelected} total={versionData.environmentalScore}/>
                  <EvaluationChartItem criteria={versionData.criterionListSocial} color={criteriaColors.soc} withCharts={!isCriterionSelected} total={versionData.socialScore}/>
                  <EvaluationChartItem criteria={versionData.criterionListEconomical} color={criteriaColors.eco} withCharts={!isCriterionSelected} total={versionData.economicalScore}/>
                  <TotalEvaluationChart  criteria={versionData.criterionList} withCharts={!isCriterionSelected} total={versionData.totalResult}/>
                  </Column>
                )}
              </GridContainer>
            </div>

          </div>
        :
          // mini view of grid
          <div style={{maxWidth: 300, overflowX: "auto"}}>

            <div>
              <MiniRowName>Hodnocení lokality:</MiniRowName>
              <MiniChartsRow versions={projectVersions}>
                {versionsData.length > 0 &&
                  <EvaluationChartItem criteria={versionsData[0].criterionListLocality} color={criteriaColors.loc}
                                       withCharts={!isCriterionSelected} total={versionsData[0].localityScore}/>}
              </MiniChartsRow>
            </div>

            <div>
              <MiniRowName style={{fontWeight: 700, color: "#000", display: "inline"}}>Hodnocení budovy:</MiniRowName>
              <MiniChartsRow versions={versionsData}>
                {versionsData.map((version) =>
                  currentOpenedVersion === version.projectVersionId ?
                    <h5 style={{fontWeight: 700,}} key={version.version}>V.{version.version}</h5>
                    :
                    <h5 key={version.version}>V.{version.version}</h5>)}
              </MiniChartsRow>
            </div>

            <div>
              <MiniRowName>Environmentální kritéria:</MiniRowName>
              <MiniChartsRow versions={projectVersions}>
                {versionsData &&
                  versionsData.map((el, index) =>
                    <EvaluationChartItem key={index} criteria={el.criterionListEnvironmental} color={criteriaColors.env}
                                         withCharts={!isCriterionSelected}  total={el.environmentalScore}/>)
                }
              </MiniChartsRow>
            </div>

            <div>
              <MiniRowName>Sociální kritéria:</MiniRowName>
              <MiniChartsRow versions={projectVersions}>
                {versionsData &&
                  versionsData.map((el, index) =>
                    <EvaluationChartItem key={index} criteria={el.criterionListSocial} color={criteriaColors.soc}
                                         withCharts={!isCriterionSelected}  total={el.socialScore}/>)
                }
              </MiniChartsRow>
            </div>

            <div>
              <MiniRowName>Ekonomická kritéria:</MiniRowName>
              <MiniChartsRow versions={projectVersions}>
                {versionsData &&
                  versionsData.map((el, index) =>
                    <EvaluationChartItem key={index} criteria={el.criterionListEconomical} color={criteriaColors.eco}
                                         withCharts={!isCriterionSelected} total={el.economicalScore}/>)
                }
              </MiniChartsRow>
            </div>

            <div>
              <MiniRowName >Celkové průběžné hodnocení projektu:</MiniRowName>
              <MiniChartsRow versions={projectVersions}>
                {versionsData &&
                  versionsData.map((el, index) =>
                    <TotalEvaluationChart key={index} criteria={el.criterionList} withCharts={!isCriterionSelected} total={el.totalResult}/>)
                }
              </MiniChartsRow>
            </div>
          </div>}
        <div style={{display:"flex", justifyContent:"space-between", marginTop: 20}}>
          {isLoading ?
            <LoadingIcon />
            :
            <div onClick={() =>this.fetchDataForCharts()}>
              <FlatButton label={"přepočítat"} backgroundColor={"#98FB98"}/>
            </div>
          }
          {isCriterionSelected &&
            <div onClick={() =>this.openFullViewGrid()}>
              <FlatButton label={"plné zobrazení"} backgroundColor={"#EDEDED"}/>
            </div>
          }
        </div>

      </div>
    )
  }


}



// WEBPACK FOOTER //
// ./src/sbtool/component/ProjectVersionParamsForm/EvaluationGrid/EvaluationGrid.tsx